// Foundations
import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

// Models
import { BinaryChoice } from 'src/app/models/binary-choice.model';

@Component({
  selector: 'app-binary-choice-selector',
  templateUrl: './binary-choice-selector.component.html',
  styleUrls: ['./binary-choice-selector.component.scss']
})
export class BinaryChoiceSelectorComponent implements OnInit {

  // BinaryChoice objects as input
  @Input() opt1: BinaryChoice = { text: 'Option 1', value: 'opt1' };
  @Input() opt2: BinaryChoice = { text: 'Option 2', value: 'opt2' };

  // Two-way binding for current selection
  @Input() selectedValue: any = null;
  @Output() selectedValueChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  optionSelected(opt): void {
    if (this.selectedValue === opt.value) {
      this.selectedValue = null;
      this.selectedValueChange.emit(null);
      return;
    }

    this.selectedValue = opt.value;
    this.selectedValueChange.emit(this.selectedValue);
  }

}
